import React from 'react';
import { Box, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './CancelSessionModal.css';
import CancelIcon from '../../../assets/Model/reject-icon.svg';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '8px',
  width: '400px',
  padding: '24px',
  textAlign: 'center',
};

const CancelSuccessDialog = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box className="flex justify-end">
          <CloseIcon onClick={onClose} sx={{ cursor: 'pointer', color: '#666666' }} />
        </Box>
        <Box className="flex flex-col items-center gap-4 mt-2">
          <img
            src={CancelIcon}
            alt="Cancelled"
            className="cancel-success-icon"
            style={{ width: 200, height: 100 }}
          />
          <Typography className="cancel-success-title">Cancelled</Typography>
          <Typography className="cancel-success-message">
            Your session has been cancelled.
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default CancelSuccessDialog;
